import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// import CardActions from '@mui/material/CardActions';
// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const ValetVizCustomerCard = ({ customer, flightTimes }) => {
  //   console.log(flightTimes);
  return (
    <Box sx={{ minWidth: 275 }}>
      <Card sx={{ minWidth: 275 }} elevation={20}>
        <CardContent>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            {customer.flightId}
          </Typography>
          <Typography variant="h5" component="div">
            {customer.pnr}
          </Typography>
          <Typography sx={{ mb: 1.5 }}>
            {`${customer.firstName} ${customer.lastName}`}
          </Typography>
          <Typography
            sx={{ textDecoration: 'underline' }}
            variant="caption"
            component="div"
            color="text.secondary"
          >
            Scheduled Times
          </Typography>
          <Typography variant="body2">{`${dayjs
            .utc(flightTimes.schedDep)
            .format('hh:mm a')} - ${dayjs
            .utc(flightTimes.schedArr)
            .format('hh:mm a')}`}</Typography>
          <Typography
            variant="caption"
            component="div"
            sx={{ textDecoration: 'underline' }}
            color="text.secondary"
          >
            Estimated Times
          </Typography>
          <Typography variant="body2">{`${dayjs
            .utc(flightTimes.estDep)
            .format('hh:mm a')} - ${dayjs
            .utc(flightTimes.estArr)
            .format('hh:mm a')}`}</Typography>
        </CardContent>
        {/* <CardActions>
          <Button size="small">Learn More</Button>
        </CardActions> */}
      </Card>
    </Box>
  );
};

export default ValetVizCustomerCard;
